import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'loanTerm',
})
export class LoanTermPipe implements PipeTransform {
  transform(loanStart: string, loanEnd: string): number {
    const start = new Date(loanStart);
    const end = new Date(loanEnd);

    let months =
      (end.getFullYear() - start.getFullYear()) * 12 +
      (end.getMonth() - start.getMonth());

    if (end.getDate() < start.getDate()) {
      months--;
    }

    return Math.max(0, months);
  }
}
